import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Stonewool Benefits`('0.0.1')({
  gutterless: true,
  view: () => <UI.Modules.Page.Reusable value={ {path: '', name: 'Stonewool Benefits' } } />,
  edit: {}
});
